var _style, _g, _path, _path2, _g2, _polygon, _ellipse, _ellipse2, _path3, _path4, _path5, _ellipse3, _rect, _path6, _circle, _path7, _circle2, _path8, _circle3, _path9, _g3, _g4, _g5, _g6, _g7, _defs, _polygon2, _defs2, _polygon3, _g8, _g9, _g0, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeste2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#504C5A;}\n\t.st1{fill:#FF9000;}\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:0.6238;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#504C5A;stroke-width:1.0888;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#504C5A;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#504C5A;stroke-width:1.103;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:#FFFFFF;}\n\t.st7{fill:#D17E12;}\n\t.st8{fill:#8155FF;}\n\t.st9{fill:none;stroke:#F0E0DF;stroke-width:2.2132;stroke-miterlimit:10;}\n\t.st10{fill:#F88AA0;}\n\t.st11{fill:none;stroke:#FFFFFF;stroke-width:2.0174;stroke-miterlimit:10;}\n\t.st12{fill:#FFA80A;}\n\t.st13{fill:#FFCB2D;}\n\t.st14{fill:#F67B91;}\n\t.st15{fill:#F6F6F6;}\n\t.st16{opacity:0.71;}\n\t.st17{clip-path:url(#SVGID_2_);fill:#FFFFFF;}\n\t.st18{clip-path:url(#SVGID_4_);fill:#FFFFFF;}\n\t.st19{fill:#8054FF;}\n\t.st20{fill:#2B4183;}\n\t.st21{fill:#7041FD;}\n\t.st22{fill:#FA849B;}\n\t.st23{fill:#181F42;}\n\t.st24{fill:none;stroke:#FFFFFF;stroke-width:1.5042;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st25{fill:#FFCD2E;}\n\t.st26{fill:#F2BB19;}\n\t.st27{fill:#E6728C;}\n\t.st28{fill:#312725;}\n\t.st29{fill:#F8879D;}\n\t.st30{fill:none;stroke:#312725;stroke-width:0.5974;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st31{fill:none;stroke:#FFFFFF;stroke-width:1.5477;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st32{fill:#243B77;}\n\t.st33{fill:#32292A;}\n\t.st34{fill:none;stroke:#312725;stroke-width:0.6026;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st35{fill:none;stroke:#281F27;stroke-width:0.7565;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M167.3,387.5c5.3,0.6,10.1,1.7,14.5,3.2l0,0c0.1,0,0.1,0,0.2,0.1c0.2,0.1,0.3,0.1,0.5,0.2 c26.4,9.4,38.5,7.7,48.9,4.5c28-8.6,44.7-45.7,90.1-38.5c19.3,3,34.8,7.2,46.8,15.6l0,0c0.1,0.1,0.2,0.1,0.3,0.2 c1.7,1.2,3.4,2.5,5,3.7c23.6,15.4,47.1-4.7,53.9-9.2c0.5-0.4,1-3.2,1.5-3.6c0.3-0.2,0.4-0.3,0.4-0.3l0,0c29.6-20.9,76.7-42,122-36.8 c78,8.9,109.3,97.3,109.3,97.3H406.8h-20.7H224.5h-35.6H78.3C87.4,402.9,123.8,382.5,167.3,387.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.2,162.6h45.9c1.1,0,1.9-0.9,1.9-1.9v-12.8c0-1.1-0.9-1.9-1.9-1.9h-45.9c-1.1,0-1.9,0.9-1.9,1.9v12.8 C106.3,161.8,107.1,162.6,108.2,162.6z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 116,
    y1: 152.5,
    x2: 148.6,
    y2: 152.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 116,
    y1: 156.2,
    x2: 125.6,
    y2: 156.2
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "150.1,160.4 150.1,167.9 140.6,160.4 "
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 646.9,
    cy: 235.8,
    rx: 5.6,
    ry: 5.7
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 85.6,
    cy: 271.5,
    rx: 8,
    ry: 8.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M389,103.1c0,1.7-1.4,3.1-3,3.1s-3-1.4-3-3.1s1.4-3.1,3-3.1S389,101.4,389,103.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M127.6,86.6h130.1c0,0-0.6-5.2-15.1-9.3c-14.5-4.1-24.8,6.5-41.2,0c-16.3-6.5-25-15.7-46.1-10.6 C134.3,71.9,127.6,86.6,127.6,86.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M539.9,132.2h67.3c0,0-0.3-3.2-7.8-5.8c-7.5-2.6-12.8,4.1-21.3,0c-8.4-4.1-12.9-9.9-23.8-6.6 C543.4,123,539.9,132.2,539.9,132.2z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 482.5,
    cy: 65.7,
    rx: 22,
    ry: 22
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 241.4,
    y: 193,
    className: "st6",
    width: 228.9,
    height: 229.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M470.3,156.9V193H241.4v-36.1c0-7.2,5.8-13,13-13h202.9C464.5,143.9,470.3,149.7,470.3,156.9z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 434.8,
    cy: 166.3,
    r: 10.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M434.8,170.4L434.8,170.4c3.4,0,6.2-2.8,6.2-6.2v-27.9c0-3.4-2.8-6.2-6.2-6.2l0,0c-3.4,0-6.2,2.8-6.2,6.2v27.9 C428.6,167.6,431.4,170.4,434.8,170.4z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 358.8,
    cy: 166.3,
    r: 10.8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M358.8,170.4L358.8,170.4c3.4,0,6.2-2.8,6.2-6.2v-27.9c0-3.4-2.8-6.2-6.2-6.2l0,0c-3.4,0-6.2,2.8-6.2,6.2v27.9 C352.6,167.6,355.4,170.4,358.8,170.4z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 282.8,
    cy: 166.3,
    r: 10.8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M282.8,170.4L282.8,170.4c3.4,0,6.2-2.8,6.2-6.2v-27.9c0-3.4-2.8-6.2-6.2-6.2l0,0c-3.4,0-6.2,2.8-6.2,6.2v27.9 C276.6,167.6,279.4,170.4,282.8,170.4z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 393,
    y: 229.9,
    className: "st9",
    width: 43.5,
    height: 43.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.1,
    y: 229.9,
    className: "st9",
    width: 43.5,
    height: 43.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.2,
    y: 229.9,
    className: "st9",
    width: 43.5,
    height: 43.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 393,
    y: 285.1,
    className: "st9",
    width: 43.5,
    height: 43.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.1,
    y: 285.1,
    className: "st9",
    width: 43.5,
    height: 43.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.2,
    y: 285.1,
    className: "st10",
    width: 43.5,
    height: 43.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 292.8,
    y1: 300.7,
    x2: 304.9,
    y2: 313.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 304.9,
    y1: 300.7,
    x2: 292.8,
    y2: 313.1
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 393,
    y: 340.4,
    className: "st9",
    width: 43.5,
    height: 43.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.1,
    y: 340.4,
    className: "st9",
    width: 43.5,
    height: 43.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.2,
    y: 340.4,
    className: "st9",
    width: 43.5,
    height: 43.5
  }))), /*#__PURE__*/React.createElement("g", null, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 445.2,
    y: 271.3,
    className: "st12",
    width: 21.2,
    height: 13.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M469.6,274.9h-27.7c-3.2,0-5.7-2.6-5.7-5.7l0,0c0-3.2,2.6-5.7,5.7-5.7h27.7c3.2,0,5.7,2.6,5.7,5.7l0,0 C475.3,272.4,472.8,274.9,469.6,274.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 394.2,
    y: 296.7,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -96.0783 373.349)",
    className: "st12",
    width: 16.9,
    height: 11.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M408.2,292l-16.7,16.7c-1.7,1.7-4.4,1.7-6.1,0l0,0c-1.7-1.7-1.7-4.4,0-6.1l16.7-16.7c1.7-1.7,4.4-1.7,6.1,0 l0,0C409.9,287.6,409.9,290.3,408.2,292z"
  })))), /*#__PURE__*/React.createElement("g", null, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -114.6402 424.8341)",
    className: "st14",
    cx: 455.5,
    cy: 350.8,
    rx: 71.6,
    ry: 71.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 455.5,
    cy: 350.8,
    r: 67.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -114.6402 424.8341)",
    className: "st15",
    cx: 455.5,
    cy: 350.8,
    rx: 60.1,
    ry: 60.1
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_1_",
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -114.6402 424.8341)",
    cx: 455.5,
    cy: 350.8,
    rx: 60.1,
    ry: 60.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "389.8,303.3 480.8,444.4 522,409.1 431.9,282.7  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_3_",
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -114.6402 424.8341)",
    cx: 455.5,
    cy: 350.8,
    rx: 60.1,
    ry: 60.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "438.3,269.3 529.4,410.4 534.7,392.7 444.6,266.4  "
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M455.8,304.3c-0.8,0-1.5-0.7-1.5-1.5v-3.5c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v3.5 C457.3,303.6,456.6,304.3,455.8,304.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M455.8,404.7c-0.8,0-1.5-0.7-1.5-1.5v-3.5c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v3.5 C457.3,404,456.6,404.7,455.8,404.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M421.6,318.5c-0.4,0-0.8-0.1-1.1-0.4l-2.5-2.5c-0.6-0.6-0.6-1.5,0-2.1s1.5-0.6,2.1,0l2.5,2.5 c0.6,0.6,0.6,1.5,0,2.1C422.3,318.3,422,318.5,421.6,318.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M492.6,389.5c-0.4,0-0.8-0.1-1.1-0.4l-2.5-2.5c-0.6-0.6-0.6-1.5,0-2.1s1.5-0.6,2.1,0l2.5,2.5 c0.6,0.6,0.6,1.5,0,2.1C493.3,389.3,492.9,389.5,492.6,389.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M419.1,389.5c-0.4,0-0.8-0.1-1.1-0.4c-0.6-0.6-0.6-1.5,0-2.1l2.5-2.5c0.6-0.6,1.5-0.6,2.1,0 s0.6,1.5,0,2.1l-2.5,2.5C419.8,389.3,419.4,389.5,419.1,389.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M490.1,318.5c-0.4,0-0.8-0.1-1.1-0.4c-0.6-0.6-0.6-1.5,0-2.1l2.5-2.5c0.6-0.6,1.5-0.6,2.1,0 s0.6,1.5,0,2.1l-2.5,2.5C490.8,318.3,490.4,318.5,490.1,318.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M407.4,352.7h-3.5c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h3.5c0.8,0,1.5,0.7,1.5,1.5 S408.2,352.7,407.4,352.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M507.8,352.7h-3.5c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h3.5c0.8,0,1.5,0.7,1.5,1.5 S508.6,352.7,507.8,352.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M459.4,350.6h-7.2v-31.3c0-2,1.6-3.6,3.6-3.6l0,0c2,0,3.6,1.6,3.6,3.6V350.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st20",
    cx: 455.8,
    cy: 350.6,
    r: 8.3
  })))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M208.7,276.2l13.1,57.7c0.8,5.5-1.3,11-5.5,14.4l-39.1,30.5l0.7-28.1l19.5-15.9l-20.2-60.2L208.7,276.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "158.1,379.1 176.9,369.2 169.5,358.7 149.1,369.9 155.6,378.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M153.6,365.4c0,0,3.2,11.6,12.3,11l3.5,27.8l-27-34.2L153.6,365.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.4,
    y: 366.6,
    transform: "matrix(0.7852 -0.6192 0.6192 0.7852 -207.3122 179.0188)",
    className: "st6",
    width: 4.1,
    height: 43.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M166.4,380.1c0,0-2.1-0.7-5.3-0.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M167.2,384.1c0,0-2.1-0.7-5.3-0.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M168,388.2c0,0-2.1-0.7-5.3-0.5"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "174.9,413.1 176.8,392.2 164,391.5 162.1,414.5 172.6,414.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M160.4,408.1c0,0,11.1,4.7,16.3-2.9l24,14.4h-43.6L160.4,408.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.1,
    y: 419.7,
    className: "st6",
    width: 43.6,
    height: 4.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M179.8,407.2c0,0-1.8,1.2-3.7,3.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M183.5,409.1c0,0-1.8,1.2-3.7,3.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M187.2,411c0,0-1.8,1.2-3.7,3.8"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "165.5,274.8 159.6,396.5 181.9,396.5 198.2,275.2  "
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "208.7,276.2 208.7,276.2 195.1,297.4 192.3,275.7  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "266.7,255.6 253.4,256.6 255.7,243.2 269.7,244.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M277.9,254.9c-3.9,3.4-9.8,2.9-13.2-1c-3.4-3.9-2.9-9.8,1-13.2s9.8-2.9,13.2,1 C282.3,245.7,281.8,251.6,277.9,254.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M272.3,238.5c0,0-1.7-3.9-5.7-1s-7.5,8.8-1.9,16.4L272.3,238.5z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M272.3,238.5l10.7-2.7c0.9-0.3,1.9,0.2,2.2,1.1l0,0c0.3,0.8-0.1,1.6-0.8,1.9l-10.9,4.9L272.3,238.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M216.3,219.8l17.6,27.9c2.5,4.5,1.1,10.1-3.2,12.9l0,0c-4.5,2.9-10.5,1.7-13.5-2.8L197.9,231 c-2.8-4.3-2.2-10,1.4-13.6l0,0C204.3,212.4,212.9,213.6,216.3,219.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "210.8,249 211.9,233.7 215.7,255.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M224.8,244.9l38.8-4.6l-0.1,17.7l-36.1,4.6c-5.7,1.1-10.9-3.4-10.7-9.2l0,0 C216.9,249,220.3,245.3,224.8,244.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M157.7,297.4c0,0,4.3,0.3,3.6-4.6s-4.4-10.9-13.8-9.6L157.7,297.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.5,
    y: 293.5,
    className: "st25",
    width: 43.5,
    height: 43.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.5,
    y: 293.5,
    className: "st25",
    width: 43.5,
    height: 43.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M140.3,294.6c-1.1-5.1,2.1-10.2,7.2-11.4c5.1-1.1,10.2,2.1,11.4,7.2c1.1,5.1-2.1,10.2-7.2,11.4 C146.5,302.9,141.4,299.7,140.3,294.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M158.8,247.3l-0.4,39l-17.1-0.8l-0.5-37.9c-0.4-5.8,4.7-10.4,10.5-9.5l0,0 C155.8,238.9,159,242.8,158.8,247.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M180.8,231l-23.6,23c-3.9,3.4-9.6,3.2-13.3-0.4l0,0c-3.8-3.8-3.8-9.9-0.1-13.7l22.1-24.6 c3.6-3.6,9.3-4.3,13.6-1.5l0,0C185.6,217.7,186.2,226.3,180.8,231z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M207.1,214.3l-33.5-2.2c-3-0.2-8.4,5.3-8.1,8.3v54.4l43.2,1.4l4.4-55.2 C213.3,217.5,210.6,214.5,207.1,214.3z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "165.5,245.9 175.2,236.4 165.5,262.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M201.7,191.7c-0.2,2.5,1.6,4.7,4,5c2.4,0.2,4.6-1.6,4.8-4.2c0.2-2.5-1.6-4.7-4-5 C204,187.3,201.9,189.2,201.7,191.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M199.1,202.5l-0.2,11c-0.1,3.8-2.4,5.9-6.1,5.8l0,0c-3.1-0.1-6.5-1.7-6.3-5.1l1.1-17.2L199.1,202.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M199,209.8c0,0-8.9,0.6-11.5-9.5c-0.8-3.2,11.7,1.1,11.7,1.1L199,209.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M195.7,205.6L195.7,205.6c6.3,0.1,11.5-4.9,11.8-10.1l0.5-11c0.4-6.6-4.4-12.3-10.8-12.9l0,0 c-6.5-0.6-13.4,4.3-14,11.1l-0.3,8.6C182.6,199,188.3,205,195.7,205.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st30",
    points: "201,190.7 201.3,194.3 199.8,194.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M194.2,183.4c0,0,2.6-0.2,2.6,0.9c0,0,0,0.7-2.3,0.8c-2.2,0.1-2.8-0.1-3-0.8 C191.4,183.6,193,183.3,194.2,183.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M205,185.9c0,0-2.1-0.3-2.3,0.7c0,0-0.1,0.7,1.7,0.9s2.5,0,2.6-0.6C207.2,186.3,206,185.9,205,185.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M203.3,190c0,0.6,0.4,1.1,1,1.2c0.6,0,1.1-0.4,1.1-1.1c0-0.6-0.4-1.1-1-1.2 C203.9,188.9,203.4,189.4,203.3,190z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M193.9,189.5c0,0.6,0.4,1.1,1,1.2c0.6,0,1.1-0.4,1.1-1.1c0-0.6-0.4-1.1-1-1.2 C194.5,188.4,193.9,188.9,193.9,189.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M196.5,195.9c0.1,0.2,1.5,1.7,3.6,1.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M205.5,166.2c-2.4-1-8.5-2.2-9.9,3.2c-6.1-0.5-15.8-0.4-16.7,4.9c-1.4,7.8,4.1,15.4,4.1,15.4l1.5,0.8 c0,0,3.9-2,2.9-11.3c0,0,14.1,3.4,20.7-0.2C214.7,175.5,212.7,169.3,205.5,166.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M177.2,190.9c-0.2,2.5,1.6,4.7,4,4.9s4.6-1.6,4.8-4.1s-1.6-4.7-4-4.9C179.5,186.6,177.4,188.4,177.2,190.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M183,192.5c0,0,0.3-3.3-2.8-3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M182.2,212.6l20.1,1.3c0,0,0.6,6.9-8.3,6.4C184,219.8,182.2,212.6,182.2,212.6z"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "602.1,380 582.3,370.8 589.4,359.7 611,370.1 604.7,378.9  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M606.1,365.8c0,0-2.7,12.1-12.2,11.9l-2.3,28.7l26.1-36.5L606.1,365.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 583.9,
    y: 387.2,
    transform: "matrix(0.5827 -0.8127 0.8127 0.5827 -63.3472 655.2349)",
    className: "st6",
    width: 44.9,
    height: 4.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M593.6,381.4c0,0,2.1-0.8,5.4-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M593,385.6c0,0,2.1-0.8,5.4-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M592.4,389.9c0,0,2.1-0.8,5.4-0.8"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M556.2,259.5c0,0-12.9,48.3-14.8,57.8c-1.9,9.5-5.7,28.6,2.3,35.4c8,6.9,38.7,23.3,38.7,23.3l11.3-20.3 l-18.3-11L556.2,259.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "573.6,413 569.6,391.5 582.8,390.9 586.8,414.4 576,414.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M587.5,407.9c0,0-11.4,4.9-16.7-3L546,419.8h44.9L587.5,407.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.1,
    y: 419.9,
    className: "st6",
    width: 44.9,
    height: 4.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M567.5,406.9c0,0,1.9,1.3,3.8,3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M563.7,408.9c0,0,1.9,1.3,3.8,3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M559.9,410.8c0,0,1.9,1.3,3.8,3.9"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M556.2,259.5l-1.3,72.8c0,2.6,0.2,5.2,0.6,7.8l10.8,56.2H589l-6.3-63.3c0.3-11.6,4.1-24.7,5.6-38.9 c0,0,4.4-26.4-7.7-34.4L556.2,259.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M541.7,249.5l-37-13.5l-4.3,7.2l36.1,19.1c6,2.3,12.2-2.9,11.1-9.2l0,0 C547,250.2,544.5,250.5,541.7,249.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M500.1,230.5c-0.7-0.7-1.7-1-2.6-0.8c-1.2,0.3-1.7,1.5-1,2.6l0.5,0.9c-1.2,0.5-3.6,0.6-8.1-4 c-0.8-0.8-2-0.9-2.8-0.4c-0.6,0.4-0.7,1.2-0.4,1.8c0,0,0,0.1,0.1,0.1c-0.6-0.2-1.3-0.2-1.8,0.2c-0.6,0.4-0.7,1.2-0.4,1.8 c0,0.1,0.1,0.2,0.2,0.3c-0.3,0-0.6,0.1-0.8,0.3c-0.6,0.4-0.7,1.2-0.4,1.8c0.1,0.2,0.2,0.4,0.4,0.5c0.1,0.1,0.1,0.1,0.2,0.2 h-0.1c-0.6,0.4-0.7,1.2-0.4,1.8c0.1,0.2,0.2,0.4,0.4,0.5c1.2,1.3,2.5,2.3,3.7,3.1l0,0c0,0,0,0,0.1,0c0.6,0.4,1.1,0.7,1.7,1 c2.6,1.5,8.1,0.2,12.9,1l3.7-7L500.1,230.5z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 453.2,
    y: 204,
    transform: "matrix(0.401 -0.9161 0.9161 0.401 77.5581 571.1394)",
    className: "st25",
    width: 44.6,
    height: 44.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M500.7,231.2l-3.6-4.2c-0.6-0.7-1.6-0.7-2.2,0l0,0c-0.4,0.5-0.5,1.1-0.2,1.6l1.8,3.6c0,0-1.6,4.9,2.2,9.1 L500.7,231.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M558.1,250.3L544.6,261c-2.7,2.2-6.5,2.4-9.5,0.6l0,0c-4.2-2.6-6.7-4.9-3.7-8.8l14.8-15L558.1,250.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M568.5,237.4c0,0-1.8,8.8-12.4,16.9l-16.4-15.5L553,224L568.5,237.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M594.1,249.1l28.5,35.9l6.4-4.3c0,0-16.3-30.4-23.9-40c-4-5-12-3.7-14.2,2.3l0,0 C589.9,245.8,592.2,246.8,594.1,249.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M624,292.3c0.2,0.9,1,1.7,1.8,1.9c1.2,0.3,2.1-0.5,2.1-1.7v-1c1.2,0.2,3.4,1.2,5.1,7.2 c0.3,1,1.3,1.7,2.2,1.6c0.7-0.1,1.2-0.6,1.2-1.4v-0.1c0.4,0.5,1,0.7,1.6,0.7c0.7-0.1,1.2-0.6,1.2-1.4c0-0.1,0-0.2,0-0.3 c0.3,0.1,0.6,0.2,0.9,0.1c0.7-0.1,1.2-0.6,1.2-1.4c0-0.2,0-0.4-0.1-0.6c0-0.1,0-0.2-0.1-0.2h0.1c0.7-0.1,1.2-0.6,1.2-1.4 c0-0.2,0-0.4-0.1-0.6c-0.5-1.6-1-3.1-1.7-4.4l0,0c0,0,0,0,0-0.1c-0.3-0.6-0.6-1.2-1-1.7c-1.5-2.5-6.8-4-10.6-6.9l-6.4,4.3 L624,292.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M589.8,226.9l13,11.4c2.6,2.3,3.5,6,2.2,9.2l0,0c-1.8,4.6-3.7,7.5-8,5.2l-17.4-11.9L589.8,226.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M573.1,219c0,0,11.1,0.2,20.9,9.2l-8.8,16.4l-17.4-6L573.1,219z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M559.1,220c0,0-10.8,3-10.8,17.4c0,7.9,7.9,22.1,7.9,22.1l24.3,0.1c0,0,3.6-9.9,5.7-18.9 c2.1-9-4.7-17.5-13-21.8L559.1,220z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "585.2,244.6 575.7,237.8 583,252  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M565.2,224.6L565.2,224.6c3.4-0.5,4.6-2.8,4.1-6.1l-3.8-19.3l-10.2,1.6l2.8,18.6 C558.7,222.8,561.9,225.1,565.2,224.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M563.2,203c0,0,3.3,10.3-5.5,13.8l-0.8-6.2l9-6.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M555.7,211.9L555.7,211.9c6.4-0.6,11.1-5.7,10.5-11.4l-1.8-18.6h-10.7c-3.9,0.4-9.4,5.6-9,9.1l1.9,11.5 C546.9,206.8,550.3,212.4,555.7,211.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M547,196l-2.4,6.2c-0.4,0.6,0.1,1.4,0.9,1.3l4.2-0.4L547,196z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M549.2,193.1c0,0-2.3,0.1-2.2,1c0,0,0.1,0.6,2.1,0.5s2.5-0.3,2.6-0.9C551.8,193.1,550.2,193,549.2,193.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M549.3,197.6c0.1,0.5-0.3,1-0.8,1.1s-1-0.3-1.1-0.8s0.3-1,0.8-1.1S549.2,197,549.3,197.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M548.6,204.8c0,0,1.6,0,2.3-1.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M566.3,217.9l6.9,1.1c0,0-7.2,11.7-14.4,8.9c-8.2-3.2,2.7-9.4,2.7-9.4L566.3,217.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M563.4,196.8c-5.4-1.4-6.4-6.4-6.4-6.4l-14.3,2.8c0,0-2.2-14.2,14.9-16.9c8.6-1.3,14,2.8,16.9,6.9 c2.7,3.9,3,9.1,1.1,13.5c-1.4,3.1-4.9,7.5-8.7,9.5l-1.3-7.1C565.5,199.1,564.3,197.1,563.4,196.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M570.2,195.8c0,2.5-2,4.6-4.5,4.6s-4.4-2.1-4.4-4.6s2-4.6,4.5-4.6C568.2,191.2,570.2,193.3,570.2,195.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M564.2,196.9c0,0,0-3.3,3.1-2.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M592.9,177.6c1,6-3,11.8-9.1,12.8c-6,1-11.8-3-12.8-9.1c-1-6,3-11.8,9.1-12.8 C586.1,167.5,591.9,171.6,592.9,177.6z"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st35",
    x1: 690.1,
    y1: 424.4,
    x2: 53.9,
    y2: 424.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeste2);
export default __webpack_public_path__ + "static/media/teste2.4c6531fedb9e460e7b85e32e6650a83f.svg";
export { ForwardRef as ReactComponent };